var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "text": "Please Wait. It may take a while for large number of records",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "data-vv-scope": "uploadform"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Client")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.Clientlist,
      "name": "CompanyList",
      "placeholder": "Select Client",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true,
      "hide-selected": true,
      "disabled": _vm.disableclientselection
    },
    on: {
      "select": _vm.selectClient
    },
    model: {
      value: (_vm.client),
      callback: function($$v) {
        _vm.client = $$v
      },
      expression: "client"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('uploadform.client')),
      expression: "errors.has('uploadform.client')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Client field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "files",
    attrs: {
      "id": "uploadBookingData",
      "name": "uploadBookingData",
      "type": "file",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.uploadBookingData
    }
  }), _vm._v(" "), _c('span', [_vm._v("File Name")]), _vm._v(": " + _vm._s(_vm.filename) + "\n              "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('uploadform.uploadBookingData')),
      expression: "errors.has('uploadform.uploadBookingData')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Choose file to upload")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.filesource != '') ? _c('div', [_c('label', {
    staticStyle: {
      "padding": "15px 0px 5px 0px",
      "color": "#fff"
    },
    attrs: {
      "for": "uploadBookingData"
    }
  }, [_c('a', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "text-decoration": "none",
      "color": "#fff",
      "font-size": "15px"
    },
    attrs: {
      "href": _vm.filesource,
      "target": "_blank",
      "title": "Download Template"
    }
  }, [_vm._v("Download Template   "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "color": "#fff"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding": "15px 22px 5px"
    }
  }, [_c('b-input-group', {
    staticStyle: {
      "display": "flex",
      "justify-content": "end"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "title": "Submit",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.submitFile
    }
  }, [_vm._v("Submit "), _c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v("  \n              "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button",
      "title": "Reset"
    },
    on: {
      "click": _vm.resetform
    }
  }, [_vm._v("Reset "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])], 1)])]), _vm._v(" "), (_vm.flipkartprogress) ? _c('div', {
    staticClass: "progress-container-div"
  }, [_c('div', {
    staticClass: "progress-container"
  }, [_c('div', {
    class: _vm.flipkartprogressarr[0] == 'stop' ? 'circle-disabled' : ''
  }, [_c('span', {
    class: _vm.flipkartprogressarr[0] == 'complete' ? 'circle-completed' : _vm.flipkartprogressarr[0] == 'start' ? 'circle circle-loading' : 'circle'
  }, [_vm._v("1")]), _vm._v(" "), (_vm.flipkartprogressarr[0] == 'stop') ? _c('span', {
    staticClass: "progress-label"
  }, [_vm._v("Check File")]) : _vm._e(), _vm._v(" "), (_vm.flipkartprogressarr[0] == 'start') ? _c('span', {
    staticClass: "progress-label"
  }, [_vm._v("Checking File")]) : _vm._e(), _vm._v(" "), (_vm.flipkartprogressarr[0] == 'complete') ? _c('span', {
    staticClass: "progress-label"
  }, [_vm._v("File Checked")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: (_vm.flipkartprogressarr[1] == 'complete') ? 'line' : (_vm.flipkartprogressarr[1] == 'start') ? 'animated-line' : 'animated-line-disabled'
  }), _vm._v(" "), _c('div', {
    class: _vm.flipkartprogressarr[1] == 'stop' ? 'circle-disabled' : ''
  }, [_c('span', {
    class: _vm.flipkartprogressarr[1] == 'complete' ? 'circle-completed' : _vm.flipkartprogressarr[1] == 'start' ? 'circle circle-loading' : 'circle'
  }, [_vm._v("2")]), _vm._v(" "), (_vm.flipkartprogressarr[1] == 'stop') ? _c('span', {
    staticClass: "progress-label"
  }, [_vm._v("Uploade File")]) : _vm._e(), _vm._v(" "), (_vm.flipkartprogressarr[1] == 'start') ? _c('span', {
    staticClass: "progress-label"
  }, [_vm._v("Uploading")]) : _vm._e(), _vm._v(" "), (_vm.flipkartprogressarr[1] == 'complete') ? _c('span', {
    staticClass: "progress-label"
  }, [_vm._v("File Uploaded")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: (_vm.flipkartprogressarr[2] == 'complete') ? 'line' : (_vm.flipkartprogressarr[1] == 'start') ? 'animated-line' : 'animated-line-disabled'
  }), _vm._v(" "), _c('div', {
    class: _vm.flipkartprogressarr[2] == 'stop' ? 'circle-disabled' : ''
  }, [_c('span', {
    class: _vm.flipkartprogressarr[2] == 'complete' ? 'circle-completed' : _vm.flipkartprogressarr[2] == 'start' ? 'circle circle-loading' : 'circle'
  }, [_vm._v("3")]), _vm._v(" "), (_vm.flipkartprogressarr[2] == 'stop') ? _c('span', {
    staticClass: "progress-label"
  }, [_vm._v("Validate data.")]) : _vm._e(), _vm._v(" "), (_vm.flipkartprogressarr[2] == 'start') ? _c('span', {
    staticClass: "progress-label"
  }, [_vm._v("Validating - " + _vm._s(_vm.flipkartDataValiated) + " out of " + _vm._s(_vm.flipkartTotalRecord))]) : _vm._e(), _vm._v(" "), (_vm.flipkartprogressarr[2] == 'complete') ? _c('span', {
    staticClass: "progress-label"
  }, [_vm._v("Validated - " + _vm._s(_vm.flipkartDataValiated) + " records")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: (_vm.flipkartprogressarr[3] == 'complete') ? 'line' : (_vm.flipkartprogressarr[3] == 'start') ? 'animated-line' : 'animated-line-disabled'
  }), _vm._v(" "), _c('div', {
    class: _vm.flipkartprogressarr[3] == 'stop' ? 'circle-disabled' : ''
  }, [_c('span', {
    class: _vm.flipkartprogressarr[3] == 'complete' ? 'circle-completed' : _vm.flipkartprogressarr[3] == 'start' ? 'circle circle-loading' : 'circle'
  }, [_vm._v("4")]), _vm._v(" "), (_vm.flipkartprogressarr[3] == 'stop') ? _c('span', {
    staticClass: "progress-label"
  }, [_vm._v("Submit Valid record.")]) : _vm._e(), _vm._v(" "), (_vm.flipkartprogressarr[3] == 'start') ? _c('span', {
    staticClass: "progress-label"
  }, [_vm._v("Submitting " + _vm._s(_vm.FCvalidimportcount) + " / " + _vm._s(_vm.validrecordsforimport) + " record.")]) : _vm._e(), _vm._v(" "), (_vm.flipkartprogressarr[3] == 'complete') ? _c('span', {
    staticClass: "progress-label"
  }, [_vm._v("Submitted " + _vm._s(_vm.validrecordsforimport) + ".")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: (_vm.flipkartprogressarr[4] == 'complete') ? 'line' : (_vm.flipkartprogressarr[4] == 'start') ? 'animated-line' : 'animated-line-disabled'
  }), _vm._v(" "), _c('div', {
    class: _vm.flipkartprogressarr[4] == 'stop' ? 'circle-disabled' : ''
  }, [_c('span', {
    class: _vm.flipkartprogressarr[4] == 'complete' ? 'circle-completed' : _vm.flipkartprogressarr[4] == 'start' ? 'circle circle-loading' : 'circle'
  }, [_vm._v("5")]), _vm._v(" "), (_vm.flipkartprogressarr[4] == 'stop') ? _c('span', {
    staticClass: "progress-label"
  }, [_vm._v("Pending.")]) : _vm._e(), _vm._v(" "), (_vm.flipkartprogressarr[4] == 'start') ? _c('span', {
    staticClass: "progress-label"
  }, [_vm._v("completed.")]) : _vm._e(), _vm._v(" "), (_vm.flipkartprogressarr[4] == 'complete') ? _c('span', {
    staticClass: "progress-label"
  }, [_vm._v("Completed.")]) : _vm._e()])]), _vm._v(" "), (_vm.showSpinner) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.flipkartprogressarr[0] == 'complete' && _vm.flipkartprogressarr[1] == 'stop' && this.validFCPO.length > 0) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#f20808"
    }
  }, [_vm._v("\n          Click Submit to Proceed.\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.FCResumeValidation) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "1%"
    }
  }, [_c('button', {
    staticClass: "-btn",
    staticStyle: {
      "margin": "0px 10px 10px 0px"
    },
    attrs: {
      "type": "button",
      "title": "Resume Import"
    },
    on: {
      "click": _vm.resumealidation
    }
  }, [_vm._v("Resume "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showresult == true),
      expression: "showresult==true"
    }]
  }, [_vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.totalRecords))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticStyle: {
      "text-decoration-line": "underline",
      "cursor": "pointer",
      "color": "blue"
    },
    attrs: {
      "title": "Vaild Records"
    },
    on: {
      "click": function($event) {
        _vm.openUploadResultData('valid')
      }
    }
  }, [_vm._v(_vm._s(_vm.successRecords.length))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticStyle: {
      "text-decoration-line": "underline",
      "cursor": "pointer",
      "color": "blue"
    },
    attrs: {
      "title": "Invaild Records"
    },
    on: {
      "click": function($event) {
        _vm.openUploadResultData('invalid')
      }
    }
  }, [_vm._v(_vm._s(_vm.failedRecords.length))])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showuploadresult == true),
      expression: "showuploadresult==true"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showimportbutton == true && _vm.importdone == 0),
      expression: "showimportbutton==true && importdone==0"
    }],
    staticClass: "-btn btn-warning",
    staticStyle: {
      "color": "white",
      "background-color": "#ff9800",
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "title": "Import Valid Records"
    },
    on: {
      "click": _vm.importValidRecords
    }
  }, [_vm._v("Submit Valid records ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showimportbutton == false && _vm.failedRecords.length > 0 && _vm.showdownloadbutton == true),
      expression: "showimportbutton==false && failedRecords.length>0 && showdownloadbutton==true"
    }],
    staticClass: "-btn btn-warning",
    staticStyle: {
      "color": "white",
      "background-color": "#ff9800",
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "title": "Download Invalid Records"
    },
    on: {
      "click": _vm.downloadFile
    }
  }, [_vm._v("Download Invalid Records "), _c('i', {
    staticClass: "fa fa-arrow-circle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.clientFileType == 0 || _vm.clientFileType == 1) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.uploadResultData), function(data, ind) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.sellername))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.category))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.sellerpincode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pickupdate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.noofpackages))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ponumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))])])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.clientFileType == 2) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.uploadResultData), function(data, ind) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.asn))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vendorcode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vendorname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.noofpackages))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.dcsit))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))])])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.clientFileType == 3 && _vm.showtmplflag == 1) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.uploadResultData), function(data, ind) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.consignor))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pickuppincode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.consignee))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pincode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.numberofmps))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))])])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.clientFileType == 4) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.uploadResultData), function(data, ind) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pickupcity))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.consingneecity))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.numberofmps))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.numberofinvoices))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))])])
  }))])])]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showimportresult == true),
      expression: "showimportresult==true"
    }]
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.clientFileType == 0 || _vm.clientFileType == 1) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_vm._m(9), _vm._v(" "), _c('tbody', [_vm._l((_vm.importResultData), function(data, ind) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.sellername))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.category))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.sellerpincode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pickupdate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.noofpackages))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ponumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awbnumber))])])
  }), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.importResultData.length < 0),
      expression: "importResultData.length<0"
    }]
  }, [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No Records")])])], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.clientFileType == 2) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_vm._m(10), _vm._v(" "), _c('tbody', [_vm._l((_vm.importResultData), function(data, ind) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.asn))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vendorcode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vendorname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.noofpackages))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.dcsit))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))])])
  }), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.importResultData.length < 0),
      expression: "importResultData.length<0"
    }]
  }, [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No Records")])])], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.clientFileType == 3) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_vm._m(11), _vm._v(" "), _c('tbody', _vm._l((_vm.importResultData), function(data, ind) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.consignor))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pickuppincode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.consignee))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pincode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.numberofmps))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awbnumber))])])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.clientFileType == 4) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_vm._m(12), _vm._v(" "), _c('tbody', _vm._l((_vm.importResultData), function(data, ind) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pickuppincode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.requestedpickupdate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.numberofmps))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.numberofinvoices))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awbnumber))])])
  }))])])]) : _vm._e()])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.FailedResultModal = false
      }
    },
    model: {
      value: (_vm.FailedResultModal),
      callback: function($$v) {
        _vm.FailedResultModal = $$v
      },
      expression: "FailedResultModal"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Booking Data")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeFailedResultModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    attrs: {
      "id": "printMPSData"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Batch ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Client Display Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Failed Reason")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.failedRecords), function(data, ind) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.awbnumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))])])
  }), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.failedRecords.length == 0),
      expression: "failedRecords.length==0"
    }]
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("No record.")])])], 2)])]), _vm._v(" "), _c('br')])])], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "padding": "30px 0px 5px 0px",
      "color": "#fff"
    },
    attrs: {
      "for": "uploadBookingData"
    }
  }, [_c('a', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "font-size": "15px"
    },
    attrs: {
      "title": "Choose File to Upload"
    }
  }, [_vm._v("Choose File "), _c('i', {
    staticClass: "fa fa-upload",
    staticStyle: {
      "color": "#fff"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa fa-spinner fa-spin",
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n          File is processing. Please do not refresh.\n        ")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Upload Details")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Total Records")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Valid Records")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Invalid Records")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Seller Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Category")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pickup Pincode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pickup Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Number of packages")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("PO Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Message")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("ASN")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Vendor Code")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Vendor Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Number of packages")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("DC sit")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Import Status")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Consignor")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pickup Pincode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Consignee")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Destination Pincode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Number of Packages")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Message")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Batch ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pickup City")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Destination City")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Number of packages")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Number of invoices")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Message")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Import Details")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Seller Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Category")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pickup Pincode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pickup Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Number of packages")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("PO Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Import Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("AWB Number")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("ASN")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Vendor Code")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Vendor Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Number of packages")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("DC sit")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Import Status")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Consignor")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pickup Pincode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Consignee")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Destination Pincode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Number of Packages")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("AWB Number")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Batch ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pickup Pincode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pickup Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Number of packages")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Number of invoices")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("AWB Number")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-101b72cc","hasScoped":true}!./src/modules/cargobooking/views/booking/dataUpload/dataUpload.component.html
// module id = 1143
// module chunks = 3